import React, { useEffect } from "react";
import "../styles/Mapa.css";

const Mapa = () => {
  useEffect(() => {
    // Escucha el evento personalizado "scrollToContact"
    const scrollToContact = () => {
      const contactoElement = document.getElementById("contacto");
      if (contactoElement) {
        contactoElement.scrollIntoView({ behavior: "smooth" });
      }
    };

    window.addEventListener("scrollToContact", scrollToContact);

    // Limpia el evento al desmontar el componente
    return () => {
      window.removeEventListener("scrollToContact", scrollToContact);
    };
  }, []);

  return (
    <div className="container" id="sucursales">
      <h2 className="text-center mb-4">SUCURSALES</h2>

      {/* Contenedor con scroll horizontal */}
      <div className="scroll-container" id="contacto">
        <div className="row flex-nowrap">
          {/* Sucursal 1 */}
          <div className="col-12 col-md-4 mb-4">
            <div className="card fixed-card">
              <div className="card-body text">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3329.9074947769905!2d-70.61661812357714!3d-33.42565599624427!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9662cf6443016fff%3A0x3c28da770a979011!2sAv.%20Nueva%20Providencia%201881%2C%20Of.1313%2C%207500520%20Providencia%2C%20Regi%C3%B3n%20Metropolitana!5e0!3m2!1ses-419!2scl!4v1734378577890!5m2!1ses-419!2scl"
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
                <p>Av. Nueva Providencia 1881<br /> oficina 1313, Providencia</p>
                <p>Casa Central Providencia</p>
                <p>Teléfono: +56 2 6465 8542</p>
                <p>Celular: +56 9 5606 5805</p>
                <p>Email: contacto@formed.cl</p>
              </div>
            </div>
          </div>

          {/* Sucursal 2 */}
          <div className="col-12 col-md-4 mb-4">
            <div className="card fixed-card">
              <div className="card-body text">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3329.8999005492587!2d-70.61477802431025!3d-33.42585397339921!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9662cf65a92abc01%3A0xc136431a0a63954f!2sFidel%20Oteiza%201971%2C%20oficina%20302%2C%207500522%20Providencia%2C%20Regi%C3%B3n%20Metropolitana!5e0!3m2!1ses-419!2scl!4v1745642078210!5m2!1ses-419!2scl"
                  width="600"
                  height="450"
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
                <p>Fidel Oteiza 1971,<br /> oficina 302, Providencia</p>
                <p>Sucursal Fidel Oteiza/Providencia</p>
                <p>Teléfono: +56 2 2337 58578</p>
                <p>Email: contacto@formed.cl</p>
              </div>
            </div>
          </div>

          {/* Sucursal 3 */}
          <div className="col-12 col-md-4 mb-4">
            <div className="card fixed-card">
              <div className="card-body text">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3193.4592115265054!2d-73.05211632317123!3d-36.8314767785422!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9669b5d71d26e1f9%3A0x8e04691d613268bc!2sRengo%2094%2C%20oficina%2031%2C%204070281%20Concepci%C3%B3n%2C%20B%C3%ADo%20B%C3%ADo!5e0!3m2!1ses-419!2scl!4v1745642156014!5m2!1ses-419!2scl"
                  width="600"
                  height="450"
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
                <p>Rengo 94<br /> oficina 31, Concepción</p>
                <p>Sucursal Concepción</p>
                <p>Teléfono: +41 212 51 75</p>
                <p>Celular: +56 9 9920 8368</p>
                <p>Email: contacto@formed.cl</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Mapa;